











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class NumKeyPad extends Vue {

  @Prop({required: false}) hasSendButton!: boolean;
  @Prop({required: false}) isSubmitEnabled!: boolean;

  // lifecycle
  mounted() {
    document.addEventListener('keyup', this.onKeyup as EventListener);
  }
  destroyed() {
    document.removeEventListener('keyup', this.onKeyup as EventListener);
  }

  // computed

  // methods
  onKeyup(event: KeyboardEvent) {
    if ( event.key ) {
      // console.log("key=" + event.key);
      if ( event.key.match(/^\d$/) ) {
        this.onDigit(Number(event.key));
      }
      else if ( 'Enter' === event.key ) {
        this.onEnter();
      }
      else if ( 'Backspace' === event.key ) {
        this.onBackspace();
      }
    }
  }
  onDigit(digit: number, target?: HTMLButtonElement) {
    if ( target ) { target.blur(); }
    this.$emit('on-digit', digit);
  }
  onEnter(target?: HTMLButtonElement) {
    if ( target ) { target.blur(); }
    this.$emit('on-enter');
  }
  onBackspace(target?: HTMLButtonElement) {
    if ( target ) { target.blur(); }
    this.$emit('on-backspace');
  }

}
